export function numberToLetter(number: number) {
  return String.fromCharCode("A".charCodeAt(0) + number);
}

type sortingFunctionType<T> = (x: T) => string;

export function stringComparatorGenerator<T>(sortingFunction: sortingFunctionType<T>) {
  return (a: T, b: T) => {
    const aa = sortingFunction(a);
    const bb = sortingFunction(b);
    return aa > bb ? 1 : bb > aa ? -1 : 0;
  };
}

export function toTitleCase(str: string) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// This function escapes special characters in a string so that they can be used in a regex
export function escapeRegex(str: string) {
  return str.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
}
